import React, { useState, useEffect, useRef } from 'react';
import './templates.scss';
import { __ } from '@wordpress/i18n';
import { nxtInstallCall } from '../../apicall';
import { Wkit_template_Skeleton } from './skeleton'
import { useNavigate } from 'react-router-dom';

const Wdtemplates = () => {
    const [templates, setTemplates] = useState(nxtext_ajax_object?.dashData?.wdTemplates || []);
    const [isFetching, setIsFetching] = useState(false);
    const Navigate = useNavigate();

    const hasFetched = useRef(false);

    useEffect(() => {
        if (hasFetched.current) return;   // block future calls
        hasFetched.current = true;

        const fetchTemplates = async () => {
            setIsFetching(true);

            try {
                var api_body = {
                    ParPage: 9,
                    CurrentPage: 1,
                    builder_req: 1002,
                    temp_type_req: 'all',
                    freepro_req: 'all'
                };

                var wdk_api = nxtext_ajax_object.dashData.nxt_wdkit_url;
                var api_url = wdk_api + 'api/front/getfilterbrowsetemplates';
                var nonce = nxtext_ajax_object.ajax_nonce;
                var ajax_url = nxtext_ajax_object.ajax_url;

                let form = new FormData();
                form.append('action', 'nexter_temp_api_call');
                form.append('nexter_nonce', nonce);
                form.append('method', 'POST');
                form.append('api_url', api_url);
                form.append('url_body', JSON.stringify(api_body));

                var response = await fetch(ajax_url, {
                    method: 'POST',
                    body: form
                });

                var data = await response.json();

                if (data.HTTP_CODE === 200 && data.posts) {
                    nxtext_ajax_object.dashData.wdTemplates = data.posts;
                    setTemplates(data.posts);
                }
            } catch (error) {
                console.error('Error fetching templates:', error);
            }

            setTimeout(() => {
                setIsFetching(false);
            }, 800);
        };

        fetchTemplates();
    }, []);

    useEffect(() => {
        if ( (nxtext_ajax_object.pro || nxtext_ajax_object.tpgb_pro) && nxtext_ajax_object.dashData.whiteLabel?.nxt_template_tab == 'on') {
            Navigate('/');
        }
    }, [nxtext_ajax_object.dashData.whiteLabel?.nxt_template_tab]);

    return (
        <div className='nxt_wordpress_templates_inner_main nxtext_main_container'>
            <div className='nxtext_section_heading_cover'>
                <h3 className='nxtext_primary_heading'>{__('WordPress Templates', 'nexter-extension')}</h3>
                <div className='nxt_header_toggle_btn_group'>
                    { !nxtext_ajax_object.dashData.wdadded ?
                        <button onClick={(e) => nxtInstallCall(e, true,'wdesignkit')} className='nxt_blue_common_btn nxt-wd-inbtn'>{__('Enable Templates', 'nexter-extension')}</button>
                        : 
                        <>
                            { nxtext_ajax_object.pro ?
                                <a href='?page=wdesign-kit#/browse?builder=1002&plugin=[1007,1008]' target="_blank" rel="noopener noreferrer" className='nxt_blue_common_btn '>{__('Open Templates', 'nexter-extension')} </a> :
                                <a href='?page=wdesign-kit#/browse?builder=1002&plugin=[1007]' target="_blank" rel="noopener noreferrer" className='nxt_blue_common_btn '>{__('Open Templates', 'nexter-extension')} </a>
                            }
                        </>
                        
                    }
                </div>
            </div>
            <div className='nxt_wordpress_templates_box_cover_main'>
                <h3 className='nxt_inner_section_heading'>{__('Import Pre-Designed Website Templates Made with Nexter Blocks', 'nexter-extension')}</h3>
                <div className='nxt_wordpress_templates_grid_view_box'>
                    {templates.length > 0 ? templates.map((template) => {

                        const mainTitle = template.title.split(' | ')[0];

                        const livePreviewUrl = `?page=wdesign-kit#/browse?builder=${template.post_builder}&page_type=%5B%22websitekit%22%5D&search=${encodeURIComponent(mainTitle)}&free_pro=${template.free_pro}`;
                        return(
                        <div key={template.id} className='nxt_wordpress_template_box'>
                            <div className='nxt_wordpress_template_cover_img_box'>
                                <img className='nxt_wordpress_template_img' src={template.image_url} draggable={false} alt={template.title} />
                            </div>
                            <h4 className='nxt_wordpress_template_title'>{template.title}</h4>
                            {nxtext_ajax_object.dashData.wdadded ?
                                <a href={livePreviewUrl} className='nxtext_primary_btn' target="_blank" rel="noopener noreferrer"> 
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20"><path d="M17.5 13.543c.345 0 .625.28.625.625 0 .735.005 1.225-.106 1.643a3.13 3.13 0 0 1-2.21 2.209c-.418.111-.908.106-1.642.106H5.833c-.734 0-1.224.005-1.642-.107a3.13 3.13 0 0 1-2.21-2.208c-.111-.418-.106-.909-.106-1.643a.625.625 0 1 1 1.25 0c0 .814.005 1.1.063 1.318.174.647.68 1.153 1.327 1.326.218.059.503.064 1.318.064h8.334c.815 0 1.1-.005 1.318-.064l.12-.036c.589-.2 1.044-.683 1.206-1.29.059-.218.064-.504.064-1.318 0-.345.28-.625.625-.625M10 1.875c.345 0 .625.28.625.625v9.745c.358-.321.762-.75 1.148-1.196a32 32 0 0 0 1.358-1.68l.087-.117.022-.03.005-.007.001-.002h.001a.625.625 0 0 1 1.07.632l-.064.11-.002.002-.007.009-.024.033a25 25 0 0 1-.424.555 33 33 0 0 1-1.078 1.314c-.414.477-.873.97-1.301 1.348a4.6 4.6 0 0 1-.65.491c-.197.12-.47.251-.767.251s-.57-.132-.768-.251a4.6 4.6 0 0 1-.649-.491 15 15 0 0 1-1.3-1.348A33 33 0 0 1 5.78 10l-.024-.033-.007-.009-.002-.002a.625.625 0 1 1 1.006-.742l.002.002.005.007.022.03.087.116a34 34 0 0 0 1.358 1.68c.386.446.79.876 1.148 1.197V2.5c0-.345.28-.625.625-.625"/></svg>
                                    <span> {__('Download Now', 'nexter-extension')} </span> </a> :
                                <a href={template.post_url} className='nxtext_primary_btn' target="_blank" rel="noopener noreferrer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20"><path fill="#1717cc" d="M10 3.708c2.73 0 4.83 1.559 6.211 3.031a14.6 14.6 0 0 1 1.995 2.711l.105.194.028.053.008.016.003.005.001.002a.63.63 0 0 1 .028.492l-.028.067v.003l-.004.004-.008.016a7 7 0 0 1-.133.248 14.6 14.6 0 0 1-1.994 2.71c-1.381 1.473-3.483 3.03-6.211 3.031-2.73 0-4.832-1.558-6.212-3.03a14.6 14.6 0 0 1-1.994-2.711l-.106-.195-.028-.053-.011-.022a.63.63 0 0 1 0-.56v-.002l.003-.005.008-.016.028-.053.106-.194a14.6 14.6 0 0 1 1.993-2.71c1.381-1.473 3.484-3.032 6.213-3.032m0 1.25c-2.229 0-4.024 1.275-5.3 2.636a13.3 13.3 0 0 0-1.78 2.405 13.3 13.3 0 0 0 1.78 2.406c1.276 1.36 3.071 2.636 5.3 2.636 2.23 0 4.024-1.275 5.3-2.636A13.3 13.3 0 0 0 17.078 10a13.3 13.3 0 0 0-1.78-2.405c-1.275-1.36-3.07-2.636-5.298-2.636m0 2.292a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5m0 1.25a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"/></svg>
                                    <span> {__('Live Preview', 'nexter-extension')} </span>
                                </a>
                            }
                            <span className='nxt_float_box_title'>{template.title}</span>
                        </div>
                        );
                        }) : <Wkit_template_Skeleton /> }
                </div>

                <div className='tmpbtn-wrap'> 
                    { !nxtext_ajax_object.dashData.wdadded ?
                        <a href={'https://wdesignkit.com/templates?builder=1002'}  target="_blank" rel="noopener noreferrer"  className="nxt_wht_common_btn">{ __('View More Website Templates' , 'nexter-extension') }</a> 
                        : 
                        <>
                            { nxtext_ajax_object.pro ?
                                <a href='?page=wdesign-kit#/browse?builder=1002&plugin=[1007,1008]' target="_blank" rel="noopener noreferrer" className='nxt_blue_common_btn '>{__('Open Templates', 'nexter-extension')} </a> :
                                <a href='?page=wdesign-kit#/browse?builder=1002&plugin=[1007]' target="_blank" rel="noopener noreferrer" className='nxt_blue_common_btn '>{__('Open Templates', 'nexter-extension')} </a>
                            }
                        </>
                    }
                    
                </div>
            </div>
           
        </div>
    );
};

export default Wdtemplates;